/* AIOO page system: scroll reveal + auto table of contents with scroll-spy.
   Markup contract:
     [data-ap-reveal]                 fades in when scrolled into view
     [data-ap-toc-source]             container whose h2 (optionally h3[data-ap-toc]) become TOC entries
     [data-ap-toc]                    empty <nav>/<div> that receives the generated list
   No dependencies. Content stays fully visible when JS is off. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal on scroll ------------------------------------------------ */
  var items = document.querySelectorAll('[data-ap-reveal]');
  if (items.length && 'IntersectionObserver' in window && !reduce) {
    root.classList.add('ap-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el, i) {
      el.style.transitionDelay = Math.min((i % 4) * 60, 180) + 'ms';
      io.observe(el);
    });
    /* Jump-scrolls (End key, anchors, scroll restoration) skip elements without ever
       intersecting them: reveal everything that is already above the viewport bottom. */
    var ticking = false;
    function sweep() {
      ticking = false;
      var limit = window.innerHeight * 0.96;
      items.forEach(function (el) {
        if (!el.classList.contains('is-in') && el.getBoundingClientRect().top < limit) el.classList.add('is-in');
      });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(sweep); } }, { passive: true });
    /* Safety net: never leave content hidden if the observer misfires. */
    setTimeout(function () { items.forEach(function (el) { el.classList.add('is-in'); }); }, 2500);
  }

  /* ---- Table of contents + scroll-spy ---------------------------------- */
  var src = document.querySelector('[data-ap-toc-source]');
  var box = document.querySelector('[data-ap-toc]');
  if (!src || !box) return;

  var heads = Array.prototype.slice.call(src.querySelectorAll('h2, h3[data-ap-toc]'))
    .filter(function (h) { return (h.textContent || '').replace(/\s+/g, ' ').trim().length > 1; });
  if (heads.length < 3) { box.hidden = true; var lay = box.closest('.ap-legal'); if (lay) lay.style.display = 'block'; return; }

  var slugs = {};
  var ol = document.createElement('ol');
  var links = [];
  heads.forEach(function (h) {
    /* Space out inline children (e.g. a title followed by a range badge) before reading the text. */
    var clone = h.cloneNode(true);
    Array.prototype.forEach.call(clone.querySelectorAll('*'), function (n) { n.insertAdjacentText('beforebegin', ' '); n.insertAdjacentText('afterend', ' '); });
    var text = (clone.textContent || '').replace(/\s+/g, ' ').trim();
    if (!h.id) {
      var base = text.toLowerCase().replace(/[^a-z0-9Ā-ſ]+/g, '-').replace(/^-|-$/g, '').slice(0, 48) || 'sec';
      var id = base, n = 2;
      while (slugs[id] || document.getElementById(id)) { id = base + '-' + n++; }
      h.id = id;
    }
    slugs[h.id] = true;
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = text.length > 70 ? text.slice(0, 68) + '…' : text;
    li.appendChild(a); ol.appendChild(li); links.push({ a: a, h: h });
  });
  var title = box.querySelector('.ap-toc__title');
  box.appendChild(ol);
  if (title) box.insertBefore(title, ol);

  ol.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a');
    if (!a) return;
    var target = document.getElementById(a.getAttribute('href').slice(1));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
  });

  if (!('IntersectionObserver' in window)) return;
  var current = null;
  function setActive(l) {
    if (current === l) return;
    if (current) current.a.classList.remove('is-active');
    current = l; l.a.classList.add('is-active');
    if (window.innerWidth < 900 && l.a.scrollIntoView) {
      var row = ol; var x = l.a.offsetLeft - row.clientWidth / 2 + l.a.clientWidth / 2;
      row.scrollTo({ left: x, behavior: 'auto' });
    }
  }
  var spy = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      for (var i = 0; i < links.length; i++) { if (links[i].h === en.target) { setActive(links[i]); break; } }
    });
  }, { rootMargin: '-96px 0px -70% 0px', threshold: 0 });
  links.forEach(function (l) { spy.observe(l.h); });
  setActive(links[0]);
})();
